<template>
    <table-actions-menu
        position="table-action-menu--low"
    >
        <edit-button :url="route('main.courses.edit', data.id)"></edit-button>

        <link-table-action-button
            :url="route('main.courses.variations.index', {'course': data.id})"
            :label="trans('buttons.courses_variation')"
        >
            <inline-svg
                :url="require('../../../../images/actions/course.svg')"
                classes="table-action-cell__icon"
            >
            </inline-svg>
        </link-table-action-button>

        <delete-button
            :url="route('mainapi.courses.destroy', data.id)"
            :confirmTitle="this.trans('courses.note.delete_title')"
            :confirmText="this.trans('courses.note.delete_message')"
            :deleteId="data.id"
        ></delete-button>
    </table-actions-menu>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'

    export default {
        props: ['data', 'index'],

        components: {
            InlineSvg
        }
    }
</script>
